/*
 * Carrusel del hero v2 del home (flag home_hero_v2).
 *
 * El primer estado ya viene pintado desde PHP (Home/_hero.php): este script
 * solo lo mueve. Si no llega a cargar, el hero se ve igual y la tarjeta activa
 * sigue siendo un enlace.
 *
 * Nada de jQuery: va con defer, y en el home un $(document).ready registrado
 * tarde no se ejecuta (ver _feed-viewer.php).
 *
 * Rota solo cada 5 s (pedido de direccion, 27/10/2026), con todo lo que pide
 * WCAG 2.2.2 para que eso sea aceptable:
 *   - se detiene mientras el cursor esta encima o el foco esta dentro,
 *   - se detiene con la pestaña oculta,
 *   - tiene un boton visible de pausa que la persona controla,
 *   - no arranca con prefers-reduced-motion.
 * Ademas se mueve con botones, teclado, deslizando o pulsando una lateral.
 */
(function () {
    'use strict';

    var INTERVALO = 4000;

    var raiz = document.getElementById('pth-hero');
    if (!raiz) { return; }

    var escenario = raiz.querySelector('.pthh-escenario');
    if (!escenario) { return; }

    var tarjetas = Array.prototype.slice.call(escenario.querySelectorAll('.pthh-card'));
    var total = tarjetas.length;
    if (total < 2) { return; }

    var actual = raiz.querySelector('[data-pthh-actual]');
    var estado = raiz.querySelector('.pthh-estado');
    var botonPausa = raiz.querySelector('[data-pthh-pausa]');
    var carrusel = raiz.querySelector('.pthh-carrusel');
    var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var indice = 0;

    function posicion(k) {
        var d = (k - indice + total) % total;
        if (d === 0) { return 'activa'; }
        if (d === 1) { return 'sig'; }
        if (d === total - 1) { return 'ant'; }
        return 'oculta';
    }

    function pintar() {
        tarjetas.forEach(function (t, k) {
            var pos = posicion(k);
            t.classList.remove('is-activa', 'is-sig', 'is-ant', 'is-oculta');
            t.classList.add('is-' + pos);

            // Solo la activa es un enlace navegable: las laterales se pulsan
            // para traerlas al centro, y con teclado eso lo hacen los botones.
            if (pos === 'activa') {
                t.removeAttribute('tabindex');
                t.removeAttribute('aria-hidden');
            } else {
                t.setAttribute('tabindex', '-1');
                t.setAttribute('aria-hidden', 'true');
            }
        });

        if (actual) { actual.textContent = String(indice + 1); }
    }

    function ir(nuevo, enfocar) {
        indice = (nuevo + total) % total;
        pintar();
        if (enfocar) { tarjetas[indice].focus({ preventScroll: true }); }
    }

    /* ---------- rotacion automatica ---------- */

    var temporizador = null;
    var pausadoPorPersona = false;   // el boton: solo lo cambia la persona
    var encima = false;              // cursor sobre el carrusel
    var enfocado = false;            // foco dentro del carrusel

    // Navegadores sin :focus-visible: se trata todo foco como de teclado.
    function focoDeTeclado(nodo) {
        try { return nodo.matches(':focus-visible'); } catch (e) { return true; }
    }

    function debeRotar() {
        return !reducido && !pausadoPorPersona && !encima && !enfocado && !document.hidden;
    }

    function programar() {
        window.clearTimeout(temporizador);
        temporizador = null;
        if (!debeRotar()) { return; }
        temporizador = window.setTimeout(function () {
            ir(indice + 1, false);
            programar();
        }, INTERVALO);
    }

    function pintarPausa() {
        if (!botonPausa) { return; }
        botonPausa.setAttribute('aria-pressed', pausadoPorPersona ? 'true' : 'false');
        botonPausa.setAttribute('aria-label', pausadoPorPersona ? 'Reanudar la rotación' : 'Pausar la rotación');
        botonPausa.classList.toggle('is-pausado', pausadoPorPersona);
        // Mientras rota, el contador no se anuncia en cada cambio; detenido, si.
        if (estado) { estado.setAttribute('aria-live', pausadoPorPersona ? 'polite' : 'off'); }
    }

    if (!reducido && botonPausa) {
        botonPausa.hidden = false;
        botonPausa.addEventListener('click', function () {
            pausadoPorPersona = !pausadoPorPersona;
            pintarPausa();
            programar();
        });
    } else if (estado) {
        estado.setAttribute('aria-live', 'polite');
    }

    carrusel.addEventListener('mouseenter', function () { encima = true; programar(); });
    carrusel.addEventListener('mouseleave', function () { encima = false; programar(); });
    /*
     * Solo pausa el foco de teclado. Un clic con mouse (en pausa/play, en una
     * flecha) deja el foco en el boton, y como focusout no llega hasta hacer
     * clic fuera, el carrusel se quedaba detenido aunque ya se hubiera dado
     * play y retirado el puntero.
     */
    carrusel.addEventListener('focusin', function (ev) { enfocado = focoDeTeclado(ev.target); programar(); });
    carrusel.addEventListener('focusout', function (ev) {
        if (!carrusel.contains(ev.relatedTarget)) { enfocado = false; programar(); }
    });
    document.addEventListener('visibilitychange', programar);

    /* ---------- interaccion ---------- */

    /*
     * Clic en una tarjeta lateral: la trae al centro en vez de navegar. Se
     * corta aqui la propagacion para que el visor (que escucha en #pth-hero)
     * no la abra. La activa sigue su camino: visor si esta encendido, enlace
     * si no.
     */
    var deslizado = false;

    escenario.addEventListener('click', function (ev) {
        var t = ev.target.closest ? ev.target.closest('.pthh-card') : null;
        if (!t) { return; }

        if (deslizado) {
            ev.preventDefault();
            ev.stopPropagation();
            deslizado = false;
            return;
        }

        if (!t.classList.contains('is-activa')) {
            ev.preventDefault();
            ev.stopPropagation();
            ir(parseInt(t.getAttribute('data-pthh-indice'), 10), false);
            programar();
        }
    });

    raiz.querySelectorAll('[data-pthh-ir]').forEach(function (b) {
        b.addEventListener('click', function () {
            ir(indice + parseInt(b.getAttribute('data-pthh-ir'), 10), false);
            programar();
        });
    });

    // Flechas del teclado mientras el foco este dentro del carrusel.
    carrusel.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowRight') { ev.preventDefault(); ir(indice + 1, true); }
        else if (ev.key === 'ArrowLeft') { ev.preventDefault(); ir(indice - 1, true); }
    });

    /*
     * Deslizar con el dedo o arrastrar con el raton. touch-action: pan-y en el
     * CSS deja el scroll vertical de la pagina al navegador y nos da el
     * horizontal. Un umbral de 40 px separa un deslizamiento de un toque.
     */
    var inicioX = null;

    escenario.addEventListener('pointerdown', function (ev) {
        inicioX = ev.clientX;
    });

    escenario.addEventListener('pointerup', function (ev) {
        if (inicioX === null) { return; }
        var dx = ev.clientX - inicioX;
        inicioX = null;

        if (Math.abs(dx) > 40) {
            // El click que el navegador dispara despues no debe navegar.
            deslizado = true;
            ir(indice + (dx < 0 ? 1 : -1), false);
            programar();
        }
    });

    escenario.addEventListener('pointercancel', function () { inicioX = null; });

    pintar();
    pintarPausa();
    programar();
})();
